export default "__VITE_ASSET__BBCBY1fX__"